import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import socket from '../lib/socket';

Vue.use(Vuex);

const store = new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
    }),
  ],
  state: {
    user: {
      loggedIn: false,
      data: {
        email: '',
        id: '',
        color: '',
        role: 0,
        leads_sold: 0,
      },
    },
    leads: [],
    admin_leads: [],
    old_leads: [],
    receivedData: [{}],
  },
  getters: {
    user(state) {
      return state.user;
    },
    leads(state) {
      return state.leads;
    },
    adminLeads(state) {
      return state.admin_leads;
    },
    oldLeads(state) {
      return state.old_leads;
    },
    receivedLeads(state) {
      return state.receivedData;
    },
  },
  mutations: {
    SET_LOGGED_IN(state, value) {
      if (typeof value === 'boolean') {
        state.user.loggedIn = value;
      } else {
        state.user.loggedIn = false;
      }
    },

    SET_LOGOUT(state) {
      state.user.loggedIn = false;
      state.user.data.email = '';
      state.user.data.id = '';
      state.user.data.color = '';
      state.user.data.role = 0;
    },

    SET_USER(state, value) {
      if (typeof value === 'object') {
        state.user.data = value;
      } else {
        state.user.data = undefined;
      }
    },

    SET_LEADS(state, value) {
      state.leads = value;
    },

    REMOVE_LEAD(state, id) {
      const leadIndex = state.leads.findIndex((x) => x.id === id);
      state.leads.splice(leadIndex, 1);
    },
  },
  actions: {
    fetchAllLeads({ state }) {
      socket.on('all_leads', (res) => {
        state.leads = res;
      });
    },
    fetchAllAdminLeads({ state }) {
      socket.on('admin_leads', (res) => {
        state.admin_leads = res;
      });
    },
    fetchAllOldLeads({ state }) {
      socket.on('old_leads', (res) => {
        state.old_leads = res;
      });
    },
    fetchDisabledLeads({ state }) {
      socket.on('lead-select', (fetchData) => {
        state.receivedData = fetchData;
      });
    },
  },
});

export default store;
